import React from 'react';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { getPageStaticProps } from 'lib/dato-request';
import { Layout } from 'components/Layout';
import { ContentBlock2 } from 'components/Parents/ContentBlock2';
import Hero from 'components/Hero/Hero';
import { ThreeBlockGrid } from 'components/ThreeBlockGrid';
import { TestimonialCarousel } from 'components/TestimonialCarousel';
import { WhyWeStarted } from 'components/WhyWeStarted';
import { Trustbar2 } from 'components/Trustbar2';
import { ConversionPanel3 } from 'components/ConversionPanel3';
import { StructuredText } from 'react-datocms';
import { HowItWorks } from 'components/HowItWorks';
import { MUZOLOGY_SIGNUP_URL } from '@/lib/defaults';

const StepUpForStudents = ({ data }) => {
    const { page } = data;
    const { components, seo } = page;
    return (
        <Layout showLoginAndSignup={false} hideNavigationMenu={true} stepUpNav={true}>
            <NextSeo title={seo?.title} description={seo?.description} />
            <Head>
                <meta name='keywords' content={page.keywords} />
            </Head>

            <Hero
                heading={components[0].heading}
                subhead={components[0].subhead}
                richText={components[0].richText}
                ctalink={MUZOLOGY_SIGNUP_URL}
                // ctalabel={components[0].ctalabel}
                img={components[0].featuredImage}
                videoLink={components[0].videoLink}
            />
            <HowItWorks
                heading={components[1].heading}
                subhead={components[1].subhead}
                img={components[1].featuredImage}
                richText={components[1].richText}
                flip={components[1].flipSides}
                ctaButton={true}
                videoLink='https://vimeo.com/723514341'
            />
            <ContentBlock2
                img={components[2].featuredImage}
                richText={components[2].richText}
                // ctalabel={components[2].ctalabel}
                ctalink={MUZOLOGY_SIGNUP_URL}
            />
            <div className='structured-text'>
                <StructuredText data={components[9].content} />
            </div>

            <TestimonialCarousel testimonials={components[3].testimonials} />
            <Trustbar2 bgColor='#f9f9f9' logos={components[4].gallery} />
            <div className='structured-text-2'>
                <StructuredText data={components[10].content} />
            </div>
            <ThreeBlockGrid gallery={components[5].gallery} heading={components[5].heading} bgColor='#f8f8f8' padding='77px 60px' />
            <ContentBlock2
                img={components[6].featuredImage}
                richText={components[6].richText}
                // ctalabel={components[6].ctalabel}
                ctalink={MUZOLOGY_SIGNUP_URL}
            />

            <ConversionPanel3
                heading={components[12].heading}
                subhead={components[12].subhead}
                ctalabel={components[12].ctalabel}
                ctalink={MUZOLOGY_SIGNUP_URL}
                h3FontSize='25px'
                stepUp={true}
            />
            <div className='structured-text-3'>
                <StructuredText data={components[11].content} />
            </div>
            <WhyWeStarted
                heading={components[8].heading}
                subhead={components[8].subhead}
                videoLink={components[8].videoLink}
                featuredImage={components[8].featuredImage}
            />

            <style jsx>{`
                .structured-text {
                    text-align: center;
                    color: #4f4f4f;
                    font-family: Inter, sans-serf, serif;
                    padding: 0 60px;
                    padding-top: 10px;
                    font-size: 18px;
                    @media (max-width: 992px) {
                        padding: 0 40px;
                    }
                    @media (max-width: 576px) {
                        padding: 0 20px;
                    }

                    h1 {
                        margin: 0;
                        font-size: 1rem !important;
                    }
                }

                .structured-text-2 {
                    background-color: #f8f8f8;
                    font-size: 18px;
                    font-family: Inter, sans-serf, serif;

                    text-align: center;
                    color: #4f4f4f;
                    padding: 30px 80px;
                    @media (max-width: 992px) {
                        padding: 10px 40px;
                    }
                    @media (max-width: 576px) {
                        padding: 20px 20px;
                    }
                }

                .structured-text-3 {
                    font-family: Inter, sans-serf, serif;
                    font-size: 18px;
                    background-color: #fff;
                    text-align: center;
                    color: #4f4f4f;
                    padding: 30px 60px 0;
                }
            `}</style>
        </Layout>
    );
};

export async function getStaticProps() {
    return getPageStaticProps('Landing Page: Step-Up for Students');
}

export default StepUpForStudents;
